import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GlobalProvider } from './context/GlobalContext';
import Layout from './components/Layout/Layout';
import DynamicPage from './pages/DynamicPage';
import NotFound from './pages/NotFound';
import FaqAdmin from './pages/FaqAdmin';
import './App.css';

function App() {
  return (
    <GlobalProvider>
      <BrowserRouter>
        <Routes>
          {/* Tool interna standalone (sin Header/Footer) — protegida por
              VITE_FAQ_ADMIN_PASSWORD. React Router prioriza esta ruta estática
              sobre :slug, pero la declaramos primero por claridad. */}
          <Route path="/faq-admin" element={<FaqAdmin />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<DynamicPage />} />
            <Route path=":slug" element={<DynamicPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </GlobalProvider>
  );
}

export default App;
